// Команда в настройках: подпись роли, что владелец может сделать с человеком из
// списка, тексты ошибок. Правила те же, что у сервера (backend/src/cf2/api/team.py):
// главного владельца (OWNER_TELEGRAM_ID) не понижают и не убирают, себя тоже.

import type { Role, User } from '../api/types'

type Who = Pick<User, 'telegram_id' | 'role' | 'is_main_owner'>

export function roleLabel(u: Pick<User, 'role' | 'is_main_owner'>): string {
  if (u.is_main_owner) return 'Главный владелец'
  return u.role === 'owner' ? 'Владелец' : 'Участник'
}

export interface MemberActions {
  /** Какую роль можно поставить человеку; null — менять нельзя. */
  setRole: Role | null
  remove: boolean
}

export function memberActions(me: Who, member: Who): MemberActions {
  const allowed = me.role === 'owner' && member.telegram_id !== me.telegram_id && !member.is_main_owner
  if (!allowed) return { setRole: null, remove: false }
  return { setRole: member.role === 'owner' ? 'member' : 'owner', remove: true }
}

const ERRORS: Record<string, string> = {
  main_owner: 'Главного владельца нельзя понизить или убрать',
  self: 'Свою роль поменять нельзя',
  cannot_remove_self: 'Себя убрать нельзя',
  member_not_found: 'Этого человека уже нет в команде',
  owner_only: 'Это может только владелец. Обновите страницу',
}

/** Текст ошибки по коду из ответа API (`detail`); status 0 — нет связи. */
export function teamErrorText(status: number | null, detail: string | null): string {
  if (detail && ERRORS[detail]) return ERRORS[detail] ?? ''
  if (status === 0) return 'Нет связи'
  return 'Не получилось'
}
